import React from 'react';

import type { InternalTransaction } from 'types/api/internalTransaction';

import { AddressHighlightProvider } from 'lib/contexts/addressHighlight';
import { currencyUnits } from 'lib/units';
import { TableBody, TableColumnHeader, TableHeaderSticky, TableRoot, TableRow, TableTopBorder } from 'toolkit/chakra/table';
import TimeFormatToggle from 'ui/shared/time/TimeFormatToggle';

import InternalTxsTableItem from './InternalTxsTableItem';

interface Props {
  data: Array<InternalTransaction>;
  currentAddress?: string;
  isLoading?: boolean;
  top?: number;
  showBlockInfo?: boolean;
}

const InternalTxsTable = ({ data, currentAddress, isLoading, top, showBlockInfo = true }: Props) => {
  return (
    <AddressHighlightProvider>
      <TableTopBorder/>
      <TableRoot
        minW="900px"
        paddingX="24px"
      >
        <TableHeaderSticky top={ top ?? 68 }>
          <TableRow>
            <TableColumnHeader width="280px">
              Parent txn hash
              <TimeFormatToggle/>
            </TableColumnHeader>
            <TableColumnHeader width="20%">Type</TableColumnHeader>
            { showBlockInfo && <TableColumnHeader width="15%">Block</TableColumnHeader> }
            <TableColumnHeader width="25%">From/To</TableColumnHeader>
            <TableColumnHeader width="35%" isNumeric textAlign="left">
              Value { currencyUnits.ether }
            </TableColumnHeader>
          </TableRow>
        </TableHeaderSticky>
        <TableBody>
          { data.map((item, index) => (
            <InternalTxsTableItem
              key={ item.transaction_hash + '_' + index }
              { ...item }
              currentAddress={ currentAddress }
              isLoading={ isLoading }
              showBlockInfo={ showBlockInfo }
            />
          )) }
        </TableBody>
      </TableRoot>
    </AddressHighlightProvider>

  );
};

export default InternalTxsTable;
